import { useSelector } from 'react-redux'
import { CustomLink } from '../../../common/CustomLink'
import { Element } from '../../../common/html/element'
import { valToPercent } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'

export const RelationshipGroup = ({ group }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div>
      {group.map((el, index) => (
        <div
          key={index}
          className={[
            'dFlex alignItemsCenter gap1',
            group.length !== index + 1 ? 'mb1' : '',
          ].join(' ')}
        >
          <Element>
            {el.ownerOrganizationName ? (
              <OrganizationLink
                organizationId={el.ownerOrganizationId}
                organizationName={el.ownerOrganizationName}
              />
            ) : (
              el.ownerPersonName
            )}
          </Element>
          <Element>-</Element>
          <Element>{el.relationship}</Element>
          {el.percentage && (
            <Element>({valToPercent(el.percentage, locale)})</Element>
          )}
        </div>
      ))}
    </div>
  )
}

const OrganizationLink = ({ organizationId, organizationName }) => {
  return (
    <CustomLink
      target="_blank"
      to={
        COMPONENTS.companyAnalysis.components.summary.route +
        '?organizationId=' +
        organizationId
      }
    >
      <Element
        style={{
          color: '#2C73E8',
        }}
        className="whiteSpaceNowrap"
      >
        {organizationName}
      </Element>
    </CustomLink>
  )
}
